import { Chip } from '@mui/material';
import { FC } from 'react';
import './Chip.scss';

interface AppChipProps {
  label: string;
  enable: boolean;
  onClick?: () => void;
}

const AppChip: FC<AppChipProps> = ({ label, enable, onClick }) => {
  return (
    <Chip
      color={enable ? 'primary' : 'default'}
      label={label}
      disabled={!enable}
      onClick={onClick}
    />
  );
};

export default AppChip;
